import type { MessageActionUndo } from '@email/shared';
import { create } from 'zustand';

interface UndoState {
  last: MessageActionUndo | null;
  remember: (undo: MessageActionUndo) => void;
  forget: (undo: MessageActionUndo) => void;
  take: () => MessageActionUndo | null;
}

/** The latest reversible mail action, shared by toast buttons and the z key. */
export const useUndoStore = create<UndoState>()((set, get) => ({
  last: null,
  remember: (undo) => set({ last: undo }),
  forget: (undo) => set((state) => (state.last === undo ? { last: null } : state)),
  take: () => {
    const undo = get().last;
    if (undo) set({ last: null });
    return undo;
  },
}));
